<ft-related-category [page]="page" [relatedTags]="" [calcTags]="data?.title"></ft-related-category>
